import React from 'react'
import Footer from '../../Component/Footer'
import Header from '../../Component/Header'
import Menu from '../../Component/Menu'
import StockDataTable from './StockDataTable'

const Stock = () => {
    return (
        <div>
            <Header />
            <Menu />
            <div className="content-wrapper">
                <StockDataTable />
            </div>
            <Footer />
        </div>
    )
}

export default Stock